export var makerValue = 'Maker';
export var takerValue = 'Taker';